import { CloudArrowUp } from "@phosphor-icons/react";
import Backup from "@/pages/Backup";

export default function SettingsBackup() {
  return (
    <section className="border border-neutral-200 bg-white" data-testid="backup-section">
      <div className="p-4 md:p-6 border-b border-neutral-200 flex items-start gap-3">
        <CloudArrowUp size={22} weight="bold" className="text-[#002FA7] mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="label-eyebrow mb-1">Backup Database</div>
          <h3 className="font-display font-bold text-lg tracking-tight">Backup manuale e su Google Drive</h3>
          <p className="text-sm text-neutral-600 mt-1">
            Scarica un dump JSON del database, configura il backup automatico su Google Drive e gestisci il restore.
          </p>
        </div>
      </div>
      <div className="-mt-2 -mb-4">
        <Backup embedded />
      </div>
    </section>
  );
}
